import {
    Breakpoint,
    ConfirmationPrompt,
    DesktopPage,
    DesktopPageActions,
    DesktopPageSection,
    DesktopTabbedContent,
    MobilePage,
    MobilePageActions,
    MobilePageSection,
    useRouter,
} from "@relode/core";
import * as React from "react";

import { useSettingsContext, SettingsForm } from "./_infra/settingsProvider";
import { MobileSettingsActions, SettingsActionBar } from "./settingsActionBar";
import { ClientSettings } from "./clientSettings";
import { Contact } from "./contact";

export const Settings = () => (
    <SettingsForm>
        <SettingsWrapper />
    </SettingsForm>
);

const SettingsWrapper = () => (
    <>
        <Breakpoint desktop>
            <SettingsDesktop />
        </Breakpoint>
        <Breakpoint mobile>
            <SettingsMobile />
        </Breakpoint>
    </>
);

const SettingsDesktop = () => {
    const {
        contact,
        state: {
            ui: { isBusy },
        },
        actions,
        formikProps: { dirty, isValid },
    } = useSettingsContext();
    const { history, location } = useRouter();
    const handleConfirmationNavigation = async (
        pathname: string,
        shouldSaveFirst: boolean
    ) => {
        if (shouldSaveFirst) {
            await actions.saveProfile(contact);
        }

        history.push(pathname, location.state);
    };

    return (
        <DesktopPage
            pageTitle="settings"
            isBusy={isBusy}
            actions={
                <DesktopPageActions
                    title="settings"
                    pageActions={<SettingsActionBar />}
                ></DesktopPageActions>
            }
        >
            <ConfirmationPrompt
                when={dirty}
                navigate={handleConfirmationNavigation}
                shouldBlock={l => dirty}
                canSave={isValid}
            />
            <DesktopTabbedContent defaultSection="contact">
                <DesktopPageSection id="contact" label="contact">
                    <Contact />
                </DesktopPageSection>

                <DesktopPageSection id="clientSettings" label="preferences">
                    <ClientSettings />
                </DesktopPageSection>
            </DesktopTabbedContent>
        </DesktopPage>
    );
};

const SettingsMobile = () => {
    const {
        contact,
        state: {
            ui: { isBusy },
        },
        actions,
        formikProps: { dirty, isValid },
    } = useSettingsContext();
    const { history, location } = useRouter();
    const handleConfirmationNavigation = async (
        pathname: string,
        shouldSaveFirst: boolean
    ) => {
        if (shouldSaveFirst) {
            await actions.saveProfile(contact);
        }

        history.push(pathname, location.state);
    };

    const renderFooter = () => <MobileSettingsActions />;

    return (
        <MobilePage
            pageTitle="settings"
            showTabs={true}
            defaultSection="contact"
            isBusy={isBusy}
            actions={<MobilePageActions title="settings" />}
            footerActions={renderFooter}
        >
            <MobilePageSection id="contact" label="contact">
                <Contact />
            </MobilePageSection>
            <MobilePageSection id="clientSettings" label="preferences">
                <ClientSettings />
            </MobilePageSection>
        </MobilePage>
    );
};
